import actions from '../../store/actions'
import { SignUpRequest, TokenResponse } from '../../resources/auth/types'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'

export const useSignUp = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const signUp = (payload: SignUpRequest): Promise<TokenResponse> => {
        setInProgress(true)
        return mutations
            .signUp(payload)
            .then(({ data }) => {
                setInProgress(false)
                if (data) {
                    dispatch(actions.signIn(data))
                    return data
                }
                throw generateError()
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        signUp,
        inProgress,
    }
}
